import { showWebAlert, WebAlertButton } from '../components/ConfirmDialog';

export const showAlert = (title: string, message?: string, buttons?: WebAlertButton[]): void => {
  showWebAlert(title, message, buttons);
};
